import { FC } from "react";
import { round } from "lodash";
import { AmountType, MapLegendItem, SIGN } from "../@types/common";
import { BREAKPOINTS } from "../constants/common";
import { translation as t } from "../utils/translation";
import { formatNumberWithoutDot } from "../utils/ui";
import { useWindowSize } from "../hooks/useWindowWidth";
import Graph from "./graph";
import MapLegend from "./mapLegend";
import InfoItem from "./infoItem";
import Tooltip from "./tooltip";
interface Props {
  name: string;
  firstPayment: number;
  highestPayment: number;
  totalAmount: number;
  totalIrr: number;
  ProductParts: MapLegendItem[];
}
const MixResults: FC<Props> = ({
  name,
  firstPayment,
  highestPayment,
  totalAmount,
  totalIrr,
  ProductParts,
}: Props) => {
  const windowWidth = useWindowSize();
  const { EXTRA_SMALL, MEDIUM, LARGE, EXTRA_LARGE } = BREAKPOINTS;
  const mapLegendItems: MapLegendItem[] = [];
  const GraphItems: MapLegendItem[] = [];
  return (
    <div
      className={`bg-lightBlue w-full rounded-m py-6 ${
        windowWidth > EXTRA_LARGE
          ? "h-[900px] mx-2.5 px-10"
          : windowWidth > LARGE
          ? "h-[640px] mx-2.5 px-8"
          : windowWidth > MEDIUM
          ? "h-[700px] mx-2.5 px-8"
          : windowWidth > EXTRA_SMALL
          ? "mx-2.5 h-[650px] px-8"
          : "h-[650px] px-8"
      }`}
    >
      <div
        className={`text-darkBlue font-semibold ${
          windowWidth < EXTRA_LARGE
            ? "text-center pb-2 text-[18px]"
            : "text-right pt-2  pb-5 text-[22px]"
        }`}
      >
        {name}
      </div>
      <InfoItem
        title={t.TOTAL_AMOUNT}
        description={t.TOOLTIP.PREDICTED_TOTAL_INTEREST}
        amount={
          {
            value: formatNumberWithoutDot(totalAmount.toString()),
            sign: SIGN.ILS,
          } as unknown as AmountType
        }
      />
      <InfoItem
        title={t.FIRST_PAYMENT}
        description={t.TOOLTIP.FIRST_MONTHLY_REPAYMENT}
        amount={
          {
            value: formatNumberWithoutDot(firstPayment.toString()),
            sign: SIGN.ILS,
          } as unknown as AmountType
        }
      />
      <InfoItem
        title={t.HIGHEST_PAYMENT}
        description={t.TOOLTIP.MAXIMUM_MONTHLY_REPAYMENT}
        amount={
          {
            value: formatNumberWithoutDot(highestPayment.toString()),
            sign: SIGN.ILS,
          } as unknown as AmountType
        }
      />
      <InfoItem
        title={t.TOTAL_INTEREST}
        description={t.TOOLTIP.PREDICTED_TOTAL_INTEREST}
        amount={
          {
            value: round(totalIrr, 2).toString(),
            sign: SIGN.PERCENT,
          } as unknown as AmountType
        }
      />
      <div className="productPartGraph">
        <div
          className={`flex flex-row justify-between items-center mb-4 ${
            windowWidth < EXTRA_LARGE
              ? "text-[18px] font-normal"
              : "text-[22px] font-semibold"
          }`}
        >
          <span
            className={`text-darkBlue ${
              windowWidth < EXTRA_LARGE ? "leading-4" : "my-5"
            }`}
          >
            {t.MORTGAGE_PERCENTS}
          </span>
          <Tooltip message={t.TOOLTIP.MORTGAGE_PERCENTS} />
        </div>
        {ProductParts.map((item, index) => {
          GraphItems.push(item);
          return <span key={index}></span>;
        })}
        <Graph items={GraphItems} />
      </div>
      <div className="productPartMapLegend mb-[70px]">
        {ProductParts.map((item, index) => {
          const mapLegendItem: MapLegendItem = {
            color: item.color,
            percent: item.percent,
            text: item.text,
        };
          mapLegendItems.push(mapLegendItem);
          return <span key={index}></span>;
        })}
        <MapLegend items={mapLegendItems} />
      </div>
    </div>
  );
};
export default MixResults;